import { SSpace } from './Space.styles';
import { TSpaceProps } from './Space.types';

export const Space = ({ ...props }: TSpaceProps) => {
  return <SSpace {...props} />;
};
